<h1 class="h3 mb-2 text-gray-800">Plan de tratamiento ingresado</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Plan de Tratamiento</h6>
    </div>
    <div class="card-body">
        <form>
            <app-planform [archivos]="archivos" [isAdmin]="isAdmin" [editable]="false" [isRefinamiento]="false" [planForm]="plantratamiento"></app-planform>
        </form>
    </div>
</div>
